export default __webpack_public_path__ + "static/media/X8000G6A.a26497c5.png";